<template>
   <v-simple-table class="price-table">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="price-title">-</th>
              <th class="price-title">{{$lang.payment.title_basic}}</th>
              <th class="price-title">{{$lang.payment.title_premium}}</th>
              <th class="price-title">{{$lang.payment.title_corp}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in permissions" :key="item.name">
              <td>
                <div class="price-feature-type"><span v-html="$lang.price[item.name]"></span>

    <v-tooltip
                  v-if="!!item.tooltip"
                  :open-on-click="true"
                  transition="slide-x-transition"
                  close-delay="500"
                  content-class="price-tooltip"
                  style="margin-left:10px;"
                  max-width="300px"
                  right
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      :size="15"
                      color="warning"
                      class="feature-info"
                      @click.stop.prevent
                    >{{localIcons['mdi-help-circle']}}</v-icon>
                  </template>
                  <span style="text-align:center" v-html="item.tooltip"></span>
                </v-tooltip>
                </div>
              </td>
              <td> 
                <v-tooltip top v-if="!!item.basicTooltip">
                  <template v-slot:activator="{ on }">
                      <div v-show="!!item.basicText" v-on="on">{{item.basicText}}</div>
                      <v-icon v-show="!item.basicText" v-on="on" class="icon" :class="'mdi-'+item.basic">{{ localIcons['mdi-'+item.basic] }}</v-icon>
                  </template>
                   <span style="text-align:center" v-html="item.basicTooltip"></span>
                </v-tooltip>

                <div v-if="!item.basicTooltip">
                    <div v-show="!!item.basicText">{{item.basicText}}</div>
                    <v-icon v-show="!item.basicText" class="icon" :class="'mdi-'+item.basic">{{ localIcons['mdi-'+item.basic] }}</v-icon>
                </div>
              </td>
              <td> 
                <v-tooltip top v-if="!!item.premiumTooltip">
                  <template v-slot:activator="{ on }">
                      <div v-show="!!item.premiumText" v-on="on">{{item.premiumText}}</div>
                      <v-icon v-show="!item.premiumText" v-on="on" class="icon" :class="'mdi-'+item.premium">{{ localIcons['mdi-'+item.premium] }}</v-icon>
                  </template>
                   <span style="text-align:center" v-html="item.premiumTooltip"></span>
                </v-tooltip>
                <div v-if="!item.premiumTooltip">
                      <div v-show="!!item.premiumText">{{item.premiumText}}</div>
                      <v-icon v-show="!item.premiumText" class="icon" :class="'mdi-'+item.premium">{{ localIcons['mdi-'+item.premium] }}</v-icon>
                </div>
              </td>
              <td> 
                <v-tooltip top v-if="!!item.corpTooltip">
                  <template v-slot:activator="{ on }">
                      <div v-show="!!item.corpText" v-on="on">{{item.corpText}}</div>
                      <v-icon v-show="!item.corpText" v-on="on" class="icon" :class="'mdi-'+item.corp">{{ localIcons['mdi-'+item.corp] }}</v-icon>
                  </template>
                   <span style="text-align:center" v-html="item.corpTooltip"></span>
                </v-tooltip>
                <div v-if="!item.corpTooltip">
                      <div v-show="!!item.corpText">{{item.corpText}}</div>
                      <v-icon v-show="!item.corpText" class="icon" :class="'mdi-'+item.corp">{{ localIcons['mdi-'+item.corp] }}</v-icon>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
</template>

<script>
import textHelper from "@/utils/textManager";
import { mdiHelpCircle,mdiCheckCircle,mdiInformation,mdiCloseCircle} from '@mdi/js'
export default {
  name: "price-table",
  components: {},
  data() {
    return {
        supportedLanguages:'',
        supportedTranslatedLanguages:'',
        localIcons:{
          'mdi-help-circle':mdiHelpCircle,
          'mdi-check-circle':mdiCheckCircle,
          'mdi-information':mdiInformation,
          'mdi-close-circle':mdiCloseCircle
        },
         permissions: [
          {
            name: 'monthly_free_minutes',
            desc:'',
            icon: 'mdi-account-hard-hat',
            basicText: '0 ',
            premiumText: '120 ',
            corpText: '1000 ',
            tooltip:'',
          },
          {
            name: 'minutes_price',
            basicText: '$8 / ',
            premiumText: '$6 / ',
            corpText: '$4 / ',
            tooltip:''
          },
          {
            name: 'additional_seat',
            basicText: 'N/A',
            premiumText: '$10 ',
            corpText: '$10 ',
            tooltip:''
          },
          {
            name: 'monthly_free_ai_credits',
            desc:'',
            icon: 'mdi-flash-auto',
            basicText: '',
            premiumText: '',
            corpText: '',
            tooltip:'',
          },
          {
            name: 'max_file_length',
            basicText: '5',
            premiumText: '5',
            corpText: '5',
            tooltip:''
          },
          {
            name: 'max_file_size',
            basicText: '2GB',
            premiumText: '5GB',
            corpText: '5GB',
            tooltip:''
          },
          {
            name: 'max_label_number',
            basicText: '1',
            premiumText: '∞',
            corpText: '∞',
            tooltip:''
          },
          {
            name: 'automated_transcription',
            basic: 'check-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'editing_platform_unlimited',
            basic: 'check-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'language_supported',
            basic: 'check-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'highlight_text',
            basic: 'check-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'translate',
            basic: 'information',
            premium: 'information',
            corp: 'information',
          },
          {
            name: 'personal_dictionary',
            basic: 'check-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'allow_commercial',
            basic: 'check-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'mp4_export',
            basic: 'information',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'mp4_multi_language_export',
            basic: 'information',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'mp4_audio_export',
            basic: 'information',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'translation_memory',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'editing_font_size',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'custom_format',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'clipped_video',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'auto_extent_subtitle',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'direct_link',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'high_definition',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'editable_transcript_sharing',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'dark_mode',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'video_editing',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'multi_upload',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'video_cutting',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'max_char',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'invoice_company',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'invoice_taxid',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'share_minutes',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'permission_users',
            basic: 'close-circle',
            premium: 'check-circle',
            corp: 'check-circle',
          },
          {
            name: 'api_integration',
            basic: 'close-circle',
            premium: 'close-circle',
            corp: 'check-circle'
          },
          {
            name: 'advanced_training',
            basic: 'close-circle',
            premium: 'close-circle',
            corp: 'check-circle'
          },
          {
            name: 'custom_payments',
            basic: 'close-circle',
            premium: 'close-circle',
            corp: 'check-circle'
          }
        ]

    };
  },
  methods: {
    addTooltip(){
      const me = this;
      me.permissions.map(function(item){
        const tooltipName = item.name+'_tooltip';
        if(me.$lang.price[tooltipName]){
          if(tooltipName === 'monthly_free_ai_credits_tooltip'){
            item.tooltip =me.$lang.price[tooltipName].format(5,30);
          }
          else{
            item.tooltip =me.$lang.price[tooltipName];
          }
        }
      });
    },
    addPermissionTooltip(){
      const me = this;
      me.permissions.map(function(item){
        const basicTooltipName = item.name+'_basic_tooltip';
        const premiumTooltipName = item.name+'_premium_tooltip';
        const corpTooltipName = item.name+'_corp_tooltip';
        if(me.$lang.price[basicTooltipName]){
          item.basicTooltip =me.$lang.price[basicTooltipName]
        }
        if(me.$lang.price[premiumTooltipName]){
          item.premiumTooltip =me.$lang.price[premiumTooltipName]
        }
        if(me.$lang.price[corpTooltipName]){
          item.corpTooltip =me.$lang.price[corpTooltipName]
        }
      });
    }

  },
  computed: {
    currentLang() {
      const me = this;
      const currentLang = me.$lang.getLang();
      return currentLang;
    }
  },
  mounted() {
    const me = this;
    me.permissions[0].basicText+=me.$lang.common.minutes;
    me.permissions[0].premiumText+=me.$lang.common.minutes;
    me.permissions[0].corpText+=me.$lang.common.minutes;

    me.permissions[1].basicText+=me.$lang.common.hour;
    me.permissions[1].premiumText+=me.$lang.common.hour;
    me.permissions[1].corpText+=me.$lang.common.hour;


    me.permissions[2].basicText = '-';
    me.permissions[2].premiumText = me.$lang.payment.per_user_per_month.format('$10');
    me.permissions[2].corpText = me.$lang.payment.per_user_per_month.format('$10');

    me.permissions[3].basicText = '0 '  + me.$lang.common.credit;
    me.permissions[3].premiumText = me.$lang.price.monthly_free_ai_credits_desc.format(5);
    me.permissions[3].corpText = me.$lang.price.monthly_free_ai_credits_desc.format(30);



    me.permissions[4].basicText+=me.$lang.common.hour;
    me.permissions[4].premiumText+=me.$lang.common.hour;
    me.permissions[4].corpText+=me.$lang.common.hour;

    me.addTooltip();



  },
  created(){
    const me = this;
    const distinctLang = textHelper.distinctLanguages(me.$lang.language);
    const distinctTransLang = textHelper.distinctLanguages(me.$lang.translatelanguage);

    distinctLang.forEach(function(code, index) {
      me.supportedLanguages += ('<span class="cell">' + code +'</span>'  );
      if ((index + 1) % 3 === 0) {
        me.supportedLanguages += "</br>";
      } else {
        me.supportedLanguages += " ";
      }
    });

    distinctTransLang.forEach(function(code, index) {
      me.supportedTranslatedLanguages += ('<span class="cell">' + code +'</span>'  );
      if ((index + 1) % 3 === 0) {
        me.supportedTranslatedLanguages += "</br>";
      } else {
        me.supportedTranslatedLanguages += " ";
      }
    });

    me.supportedTranslatedLanguages += `<div class="tooltip-note">*${me.$lang.payment.basic_feature4_tooltip}</div>`

    me.$lang.price['language_supported_tooltip'] = me.supportedLanguages;
    me.$lang.price['translate_tooltip'] = me.supportedTranslatedLanguages;

    
    me.addPermissionTooltip();
  }
};
</script>

<style scoped>
tr:hover{
  background:transparent!important;
}

.permission-container {
  padding: 30px;
  margin-left: 0px;
}

.permission-content {
  background: white;
  border-radius: 5px;
  padding: 20px;
  width: 930px;
  box-shadow: 0 5px 12px rgb(1 1 1 / 15%);
}

.price-table{
    border: 1px lightgray solid;
    padding: 10px;
    margin-right: 20px!important;
    margin-bottom: 20px;
    /* margin-top:20px; */
    border-radius: 0px 0px 10px 10px;
    border-top:0px;
}

.price-table .v-icon{
    font-size: 16px;
}

.price-table .mdi-check-circle{
    font-size: 16px;
    color:#00e0c6;
}
.price-table .mdi-information{
    font-size: 16px;
    color:rgb(32, 100, 211)
    /* color:#0062ff; */
}
.price-table .mdi-close-circle{
    font-size: 16px;
    color:#cecece;
}

.price-table th,
.price-table td 
{
  padding:0px 50px!important;
    text-align: left!important; 
    vertical-align: middle!important;
    width:25%;
}

.price-table tr td:nth-child(1){
  padding:0px 20px 0px 0px!important;
}

.price-title{
   color: #18e7d3!important;
    font-size: 16px!important;
    text-transform: capitalize;
    font-weight: 300;
}

.role-type{
    padding: 5px;
    border-radius: 5px;
    color: white;
    position:relative;
}

/* .price-tooltip{
      top: 10px;
    position: absolute;
} */

.price-table td{
  position:relative;
}

.price-table .feature-info{
  position:relative;
}

.price-feature-type{
    font-size: 15px;
    color:#797676;
    text-align: left;;
}

.price-table thead{
  display:none;
}

@media only screen and (max-device-width: 992px) {
  .price-feature-type{
    font-size: 13px;
}
  .price-table{
    margin-right: 0px!important;
  }
.price-table thead{
  display: table-row-group;
}
.price-table th.price-title{
  padding:0px!important;
  width:25%;
  text-align: center!important;
}
.price-table td{
  text-align: center!important;
}
}

@media only screen and (max-device-width: 600px) {
.price-table .feature-info{
  display:none;
}
.price-table{
  margin-right:0px!important;
}
.price-table td{
  padding:0px!important;
}
}

</style>

<style >

.price-table svg{
  width:16px;
}
</style>
